const navs = [
  { name: "labels.alerts", url: "/alerts/alerts/", icon: "triangle-exclamation", role: "tech" },
  //{ name: "labels.configuration", url: "/alerts/configuration/", icon: "gear", role: "superuser" },
  //{ name: "labels.programming", url: "/alerts/programming/", icon: "clipboard", roles: "superuser" },
]

export default navs